import React, { useState } from 'react';
import { Container, Form, Button, Alert, Row, Col } from 'react-bootstrap';
import api from '../services/api';

function UserForm({ openTab, closeTab, activeTab }) {
  const [form, setForm] = useState({
    email: '',
    first_name: '',
    last_name: '',
    role: 'viewer',
    is_active: true,
    password: '',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.email.trim() || !form.password) {
      setError('Login a heslo jsou povinné.');
      return;
    }
    setSaving(true);
    try {
      const payload = {
        email: form.email.trim(),
        first_name: form.first_name.trim(),
        last_name: form.last_name.trim(),
        role: form.role,
        is_active: form.is_active ? 1 : 0,
        password: form.password,
      };
      const result = await api.createUser(payload);
      const newId = result.data?.id;
      window.dispatchEvent(new CustomEvent('users:refresh'));
      if (closeTab && activeTab) closeTab(activeTab);
      if (newId && openTab) {
        const title = `${payload.first_name} ${payload.last_name}`.trim() || payload.email;
        openTab(`user-${newId}`, title, `/user/${newId}`, 'UserDetail', { userId: newId });
      }
    } catch (err) {
      console.error('Failed to create user:', err);
      setError(err.message || 'Vytvoření uživatele se nepodařilo.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container fluid className="px-4 py-3">
      <h4 className="mb-3">Nový uživatel</h4>

      {error && <Alert variant="danger" onClose={() => setError('')} dismissible>{error}</Alert>}

      <div className="card">
        <div className="card-body">
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Login (email)</Form.Label>
                  <Form.Control
                    type="text"
                    value={form.email}
                    onChange={(e) => handleChange('email', e.target.value)}
                    required
                    autoComplete="username"
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Jméno</Form.Label>
                  <Form.Control
                    type="text"
                    value={form.first_name}
                    onChange={(e) => handleChange('first_name', e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Příjmení</Form.Label>
                  <Form.Control
                    type="text"
                    value={form.last_name}
                    onChange={(e) => handleChange('last_name', e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="align-items-end">
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Role</Form.Label>
                  <Form.Select value={form.role} onChange={(e) => handleChange('role', e.target.value)}>
                    <option value="admin">Administrátor</option>
                    <option value="manager">Manažer</option>
                    <option value="editor">Editor</option>
                    <option value="viewer">Uživatel</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Heslo</Form.Label>
                  <Form.Control
                    type="password"
                    value={form.password}
                    onChange={(e) => handleChange('password', e.target.value)}
                    required
                    autoComplete="new-password"
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3 pb-2">
                  <Form.Check
                    type="switch"
                    id="user-new-active-switch"
                    label="Aktivní"
                    checked={form.is_active}
                    onChange={(e) => handleChange('is_active', e.target.checked)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="d-flex justify-content-end gap-2">
              {closeTab && activeTab && (
                <Button variant="outline-secondary" type="button" onClick={() => closeTab(activeTab)}>
                  Zrušit
                </Button>
              )}
              <Button variant="primary" type="submit" disabled={saving}>
                {saving ? 'Vytvářím…' : 'Vytvořit uživatele'}
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </Container>
  );
}

export default UserForm;
